import { ADD_SERIES } from "../constants/seriesConstants";

const seriesReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_SERIES:
      if (Array.isArray(action.payload)) {
        return [...state, ...action.payload];
      } else {
        return [...state, action.payload];
      }
    default:
      return state;
  }
};

export default seriesReducer;
